module.exports = __webpack_public_path__ + "prod/1.42.2/img/epidemic-present-home.a3f18567.png";